import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { LeadMobileCardBuilder } from "../partnerWeb_Dashboard/utils";
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { LeadsMobEmptyStateStack } from "./indexMobEmptyState";
import { PartnerAccountType } from "../../configs/constants";
import { showPhoneNumber } from "../../configs/utils";
import { showShareLink } from "../../configs/uri-config-utils";
export const LeadsMobStack = async (mockDATA, partnerAccountType, user, no_of_pending_registration, no_of_completed_registration) => {
    const DS = {
        leadsMobRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.XXXL,
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XXXL,
            },
            widgetItems: [
                { id: 'leadsMobT1', type: WIDGET.TEXT },
                { id: 'leadsMobT2', type: WIDGET.TEXT },
                { id: 'leadsMobRootSpace0', type: WIDGET.SPACE },
                mockDATA.length > 0 ? { id: 'leadMobButtonStack1', type: WIDGET.STACK } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootSpace1', type: WIDGET.SPACE } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootDivider0', type: WIDGET.DIVIDER } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootSpace2', type: WIDGET.SPACE } : {},
                mockDATA.length > 0 ? { id: 'filterStack_Mob', type: WIDGET.SCROLL_STACK } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootSpace2', type: WIDGET.SPACE } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootSearchInput', type: WIDGET.INPUT } : {},
                mockDATA.length > 0 ? { id: 'leadsMobRootSpace3', type: WIDGET.SPACE } : {},
                mockDATA.length > 0 ? { id: 'leadsMobCardStack', type: WIDGET.STACK } : {},
                mockDATA.length === 0 ? { id: 'leadMobEmptyStateStack', type: WIDGET.STACK } : {}
            ]
        },
        filterStack_Mob: {
            width: '100%',
            widgetItems: [
                { id: 'all_Filter_Mob', type: WIDGET.FILTER_CHIP },
                { id: 'filterStackSpace0', type: WIDGET.SPACE },
                { id: 'RegistrationPending_Filter_Mob', type: WIDGET.FILTER_CHIP },
                { id: 'filterStackSpace0', type: WIDGET.SPACE },
                { id: 'RegistrationCompleted_Filter_Mob', type: WIDGET.FILTER_CHIP }
            ]
        },
        all_Filter_Mob: {
            title: 'All',
            noOfItems: `${mockDATA.length}`,
            selected: true,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    currentStepName: 'All',
                    isMobile: true
                }
            }
        },
        RegistrationPending_Filter_Mob: {
            title: 'Registration pending',
            noOfItems: `${no_of_pending_registration}`,
            selected: false,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    filterType: 'Pending registration',
                    isMobile: true
                }
            }
        },
        RegistrationCompleted_Filter_Mob: {
            title: 'Registration completed',
            noOfItems: `${no_of_completed_registration}`,
            selected: false,
            action: {
                type: ACTION.ON_CLICK_FILTER,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    filterType: 'Registration complete',
                    isMobile: true
                }
            }
        },
        ...await LeadsMobEmptyStateStack(partnerAccountType),
        leadsMobCardStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                ...LeadMobileCardBuilder(mockDATA, partnerAccountType, user).WIDGET_STORE,
            ]
        },
        ...LeadMobileCardBuilder(mockDATA, partnerAccountType, user).DATA_STORE,
        leadsMobDetailsCard1: {
            title: 'Sonesh Navichandra Deshia',
            detailItems: [
                {
                    title: 'Status',
                    value: 'Bank Verification '
                },
                {
                    title: 'Available credit limit',
                    value: '₹30,0000'
                }
            ],
            actionItems: [
                { title: 'View detail', action: {} },
                { title: 'Share link', action: {} },
                { title: 'Register customer', action: {} },
            ]
        },
        leadsMobRootSearchInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            title: showPhoneNumber(partnerAccountType) ? 'Search applications' : 'Search applications',
            placeholder: showPhoneNumber(partnerAccountType) ? 'Search by name and phone number' : 'Search by name',
            keyboardType: KeyboardTypeToken.default,
            isFocus: false,
            action: {
                type: ACTION.ON_SEARCH_LEADS,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {
                    value: '',
                    widgetId: 'leadsMobRootSearchInput',
                },
            },
        },
        leadsMobT1: {
            label: `Pending applications`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        leadsMobT2: {
            label: `Create & track loan applications in progress`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20,
        },
        leadMobButtonStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                showShareLink(user) ? { id: 'leadShareUniqueLinkMobStack', type: WIDGET.STACK } : {},
                showShareLink(user) ? { id: 'leadMobButtonStack1Space0', type: WIDGET.SPACE } : {},
                partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL ? { id: 'leadRegisterLeadsMobStack', type: WIDGET.STACK } : {},
            ]
        },
        leadShareUniqueLinkMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'leadShareUniqueLinkMobBtn', type: WIDGET.BUTTON }
            ]
        },
        leadRegisterLeadsMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'leadRegisterLeadsMobBtn', type: WIDGET.BUTTON }
            ]
        },
        leadShareUniqueLinkMobBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Share unique link',
            fontSize: FontSizeTokens.XS,
            action: {
                type: ACTION.SHARE_LINK_REF,
                routeId: ROUTE.PARTNER_LEAD,
                payload: {}
            }
        },
        leadRegisterLeadsMobBtn: {
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Register customer',
            fontSize: FontSizeTokens.XS,
            action: {
                routeId: ROUTE.PARTNER_LEAD,
                type: ACTION.ON_REGISTER_LEADS,
                payload: {}
            }
        },
        leadsMobRootDivider0: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        leadsMobRootSpace0: {
            size: SizeTypeTokens.XL
        },
        leadsMobRootSpace1: {
            size: SizeTypeTokens.XL
        },
        leadsMobRootSpace2: {
            size: SizeTypeTokens.XL
        },
        leadsMobRootSpace3: {
            size: SizeTypeTokens.XL
        },
        leadMobButtonStack1Space0: {
            size: SizeTypeTokens.XL
        }
    };
    return DS;
};
